import { render } from "./InvestorQuotes.vue?vue&type=template&id=6c1c4dc8&scoped=true"
import script from "./InvestorQuotes.vue?vue&type=script&lang=js"
export * from "./InvestorQuotes.vue?vue&type=script&lang=js"

import "./InvestorQuotes.vue?vue&type=style&index=0&id=6c1c4dc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1c4dc8"]])

export default __exports__